import { CustomError } from '../../lib/custom-error';

/**
 * Базовый класс для описания ошибок в api.
 */
export class ApiError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }
}

/**
 * Если поле success в ответе не равно true.
 */
export class ResponseSuccessFieldError extends ApiError {
  constructor(...args: ConstructorParameters<typeof ApiError>) {
    super(...args);
  }
}
